import * as actionTypes from './actionTypes';
import axios from '../../axios';
import i18n from "../../i18n";
import {API} from '../../constants';

export const setOrdersToday = (orders) => {
    return {
        type: actionTypes.SET_ORDERS_TODAY,
        orders: orders
    };
};

export const setOrdersTomorrow = (orders) => {
    return {
        type: actionTypes.SET_ORDERS_TOMORROW,
        orders: orders
    };
};

export const setOrdersLoading = () => {
    return {
        type: actionTypes.FETCH_ORDERS_STARTING,
    };
};

export const fetchOrdersTodayFailed = () => {
    return {
        type: actionTypes.FETCH_ORDERS_TODAY_FAILED
    };
};

export const fetchOrdersTomorrowFailed = () => {
    return {
        type: actionTypes.FETCH_ORDERS_TOMORROW_FAILED
    };
};

export const initOrders = (storageId, today, tomorrow) => {
    return dispatch => {

        dispatch(setOrdersLoading());

        axios.get(`${API}${i18n.language}/angel/bookings/${storageId}/${today}`)
            .then(response => {
                dispatch(setOrdersToday(response.data ? response.data : []));
            })
            .catch(error => {
                console.log('err', error);
                dispatch(fetchOrdersTodayFailed());
            });

        axios.get(`${API}${i18n.language}/angel/bookings/${storageId}/${tomorrow}`)
            .then(response => {
                dispatch(setOrdersTomorrow(response.data ? response.data : []));
            })
            .catch(error => {
                console.log('err', error);
                dispatch(fetchOrdersTomorrowFailed());
            });
    };
};